import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { siteContent as defaultContent, videos as defaultVideos } from "../mock";
import { fetchContent, fetchVideos } from "../api";

const ContentContext = createContext({
  content: defaultContent,
  videos: defaultVideos,
  loading: true,
  refresh: () => {},
});

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaultContent);
  const [videos, setVideos] = useState(defaultVideos);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const [c, v] = await Promise.all([fetchContent(), fetchVideos()]);
      if (c && c.hero) setContent(c);
      if (Array.isArray(v) && v.length > 0) setVideos(v);
    } catch (e) {
      console.error("Content fetch failed, using defaults:", e?.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <ContentContext.Provider value={{ content, videos, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
